module.exports = __webpack_public_path__ + "media/images/help-bef8089a.svg";